export default __webpack_public_path__ + "static/media/2.04e1e6df.jpeg";